fragment FeaturedExpertsFragment on featuredExperts_Entry {
  id
  typeHandle
  tagLine
  heading
  body
  experts {
    title
    slug
    uri
    ... on expert_Entry {
      teaserText
      jobTitle
      image {
        url
        title
      }
    }
  }
}
